module.exports = __webpack_public_path__ + "img/organizaciones.6de82ef9.svg";